











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ImprimirButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
